import "./api_main.css";
import { useLocation } from "react-router-dom";
import DashboardTopBar from "../../dashboard_nav/dashboard_top_bar";
import DashboardSideBar from "../../dashboard_nav/dashboard_side_bar";
import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import APIContent from "../api_content/api_content";
import { createItem } from "../../../../api/networking";

//Icons
import { FaKey } from "react-icons/fa";
import { FaGears } from "react-icons/fa6";
import { FaDeleteLeft } from "react-icons/fa6";
import { FaTasks } from "react-icons/fa";
import { MdOutlineSubscriptions } from "react-icons/md";
import { MdSubscriptions } from "react-icons/md";
import { GoGear } from "react-icons/go";
import { IoKeyOutline } from "react-icons/io5";








const APIMain = () =>{
    const [isTopNavNavigation, setIsTopNavNavigation] = useState([true,false,false]);
    const [isSideNavNavigation, setIsSideNavNavigation] = useState([true,false,false,false,false,false]);
    const [currentAPIPageText, setCurrentAPIPageText] = useState("Overview");
    const [currentAPISubText, setCurrentAPISubText] = useState("setup");
    const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
    const [isProfileNavigation, setIsProfileNavigation] = useState([true,false,false,false]);
    const [apiKey, setApiKey] = useState(null);




    const location = useLocation();
    const isAdmin = location.state?.isAdmin || false;
    const email = location.state.email;
    // Safely extract initials string
    const initials = location.state.initials;


    const ProfilePageOnChange = (index) =>{
        let currentState = [true,false,false,false]

        //Route to different page
        switch(index){
            case 0:
                currentState = [true,false,false,false]
                break;
            case 1:
                currentState = [false,true,false,false]
                break;
            case 2:
                currentState = [false,false,true,false]
                break;
            case 3:
                currentState = [false,false,false,true]
                break;
            default:
                currentState = [true,false,false,false]
                break;

        }
        setIsProfileNavigation(currentState);
    }

    const handleFetchApiKey = async() => {
        console.log("Email: ", email)
        try{
        const response = await createItem(`/v1/users/get_api_token?email=${encodeURIComponent(email)}`);
        if (response[0] == 200){
            setApiKey(response[1]['api_key'])
        }
        
        
        }
        catch(e){
        console.log("Error")
        }

    };
    
    return(
        <div  style={{width:"100vw"}}>
            <div style={{width:"100vw"}}>
                <DashboardTopBar profileModal={isProfileModalOpen} setProfileModal={setIsProfileModalOpen} initials={initials} isTopNav={isTopNavNavigation} setIsTopNav={setIsTopNavNavigation}/>
            </div>

            {isTopNavNavigation[0]&&<div className="container">
                <div className="box-left">
                    <DashboardSideBar setSubText={setCurrentAPISubText} subText={currentAPISubText} setCurrentDashText={setCurrentAPIPageText} isSideNav={isSideNavNavigation} setIsSideNav={setIsSideNavNavigation} />
                </div>
                <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{duration: 1.5}} className="box corner-box">
                    <APIContent setSubText={setCurrentAPISubText} subText={currentAPISubText}  pageText={currentAPIPageText}/>
                </motion.div>
            </div>}

            {isTopNavNavigation[1]&&<div className="container-2">
                <motion.div initial={{ opacity: 0 }} dur animate={{ opacity: 1 }} transition={{duration: 1.5}} className="box-2">Guides Page</motion.div>
            </div>}

            {isTopNavNavigation[2]&&<div className="container-2">
                <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{duration: 1.5}} className="box-2">Support Page</motion.div>
            </div>}

            <AnimatePresence>
            {
            isProfileModalOpen && (
                <div className="profile-modal-overlay" onClick={() => setIsProfileModalOpen(false)}>
                    <motion.div 
                        initial={{ scale: 0.8, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        exit={{ scale: 0.8, opacity: 0 }} 
                        transition={{ duration: 0.2 }}
                        className="profile-modal-content"
                        onClick={(e) => e.stopPropagation()} // prevents closing when clicking inside
                    >
  
                        <div  style={{height:'100%',width:'100%',marginTop:'15px'}}>
                                
                            <div style={{height:'10px',width:'40px'}}>
                                    <button className="modal-close" onClick={() => setIsProfileModalOpen(false)}>
                                            ×
                                    </button>
                                
                            </div>

                            <div className="profile-modal-inner-menu">
                                <button type="button" onClick={()=>ProfilePageOnChange(0)} className={isProfileNavigation[0]?"profile-modal-inner-menu-button-active":"profile-modal-inner-menu-button"}>
                                    <span className="button-content">
                                        <GoGear style={{marginRight:'4px',marginLeft:'4px', color:'#296BE2'}} size={25} />
                                        <span>General</span>
                                    </span>
                                    {/*<GoGear style={{marginRight:'4px',marginLeft:'4px', color:'#296BE2'}} size={20}/> General</button>*/}
                                    </button>
                                <button type="button" onClick={()=>ProfilePageOnChange(1)} className={isProfileNavigation[1]?"profile-modal-inner-menu-button-active":"profile-modal-inner-menu-button"}>
                                    <span className="button-content">
                                        <IoKeyOutline style={{marginRight:'4px',marginLeft:'4px', color:'#296BE2'}} size={26} />
                                        <span>API-Key</span>
                                    </span>
                                    </button>

                                {/*button type="button" onClick={()=>ProfilePageOnChange(2)} className={isProfileNavigation[2]?"profile-modal-inner-menu-button-active":"profile-modal-inner-menu-button"}><MdSubscriptions style={{marginRight:'8px'}} size={25} /> Plan</button>
                                <button type="button" onClick={()=>ProfilePageOnChange(3)} className={isProfileNavigation[3]?"profile-modal-inner-menu-button-active":"profile-modal-inner-menu-button"}><FaDeleteLeft style={{marginRight:'8px'}} size={25} /> Delete Account</button>*/}
                            </div>

                           {isProfileNavigation[0]&&<div className="profile-modal-inner-content">
                                <div className="profile-modal-inner-title">
                                    <h2 style={{fontWeight:'300'}}>General Title</h2>
                                </div>
                                <div>
                                    <p>Email: {email}</p>
                                    <p>Initials: {initials}</p>
                                </div>
                            </div>}

                            {isProfileNavigation[1]&&<div className="profile-modal-inner-content">
                                <div className="profile-modal-inner-title">
                                    <h2 style={{fontWeight:'300'}}>API Key</h2>
                                </div>
                                <div>
                                    <div className="profile-modal-inner-container-apikey">
                                        <div style={{
                                            marginBottom:'20px'
                                        }}>API KEY:</div>
                                        
                                        <div className="apikey-wrapper">
                                            <div
                                            className="profile-modal-inner-input-apikey"
                                            >
                                            {apiKey || "*******************"}
                                            </div>

                                            <button
                                            className="apikey-copy-btn"
                                            onClick={() => navigator.clipboard.writeText(apiKey)}
                                            >
                                            Copy
                                            </button>
                                        </div>
                                    </div>
                                    <button className="profile-modal-inner-input-apikey-button" onClick={handleFetchApiKey}>Generate API Key</button>
                                </div>
                            </div>}

                            {isProfileNavigation[2]&&<div className="profile-modal-inner-content">
                                <div  className="profile-modal-inner-title">
                                    <h2>Subscription Plans</h2>
                                </div>
                                <div>
                                    <p>This is your modal content</p>
                                </div>
                            </div>}

                            {isProfileNavigation[3]&&<div className="profile-modal-inner-content">
                                <div  className="profile-modal-inner-title">
                                    <h2>Delete Account</h2>
                                </div>
                                <div>
                                    <p>This is your modal content</p>
                                </div>
                            </div>}

                        </div>

                    </motion.div>
                </div>
            )
            
            }</AnimatePresence>
        </div>
    );
}

export default APIMain;